<template>
    <div class="l-inner">
        <!-- <light-box /> -->
        <app-section
            :title="page.title"
            :desc="page.desc"
            :push="page.push"
            :logo="logo"
            :logo-bottom="false"
            bg-intro="lighter"
            ref="section"
            :video-url="page.video_hero"
            intro-position="bottom"
        >
            <template #content>
                <div class="p-stories__grid | l-grid">
                    <!-- cta -->
                    <hero-card :data="page.body[0]" />
                    <entrepreneur-title-text :data="page.body[1]" />
                    <app-section
                        v-for="(item, i) in stories"
                        :key="`item-${i}`"
                        tag="article"
                        :bgs="1"
                        class="p-stories"
                    >
                        <template #content>
                            <div class="p-stories__inner">
                                <!-- TODO: Loop body content -->

                                <entrepreneur-vertical-name
                                    v-if="item.data.first_name.length && item.data.last_name"
                                    :first-name="item.data.first_name[0].text"
                                    :last-name="item.data.last_name[0].text"
                                />

                                <entrepreneur-intro :data="item.data" :uid="item.uid" />
                                <entrepreneur-video
                                    v-if="findCard('video_entrepreneur', item.data.body1)"
                                    :data="findCard('video_entrepreneur', item.data.body1)"
                                    :bg="findCard('video_entrepreneur', item.data.body1).primary.bg"
                                />
                            </div>
                        </template>
                    </app-section>
                </div>
            </template>
        </app-section>
        <about />
        <push :page="page.page_push" />
    </div>
</template>

<script>
import gsap from "gsap";
import Variables from "src/mixins/variables";

import About from "layout/About";
import AnimText from "objects/AnimText";
import AppSection from "layout/AppSection";
import Asset from "objects/Asset";
import Btn from "components/Btn";
import Card from "components/Card";
import EntrepreneurIntro from "components/EntrepreneurIntro/EntrepreneurIntro";
import EntrepreneurTitleText from "components/EntrepreneurTitleText/EntrepreneurTitleText";
import EntrepreneurVerticalName from "components/EntrepreneurVerticalName/EntrepreneurVerticalName";
import EntrepreneurVideo from "components/EntrepreneurVideo/EntrepreneurVideo";
import HeroCard from "components/HeroCard/HeroCard";
import Icon from "objects/Icon";
import LightBox from "components/LightBox/LightBox";
import PrismicRichText from "objects/PrismicRichText";
import Push from "layout/Push";

export default {
    name: "Stories",
    components: {
        About,
        AnimText,
        AppSection,
        Asset,
        Btn,
        Card,
        EntrepreneurIntro,
        EntrepreneurTitleText,
        EntrepreneurVerticalName,
        EntrepreneurVideo,
        HeroCard,
        Icon,
        LightBox,
        PrismicRichText,
        Push
    },
    mixins: [Variables],
    props: {
        page: Object
    },
    data() {
        return {
            imageSize: 480,
            logo: false,
            logoBottom: false
        };
    },
    mounted() {
        this.setLogo(false);
    },
    computed: {
        stories() {
            if (this.page.related_stories.length === 0) return;

            return this.page.related_stories.map(p => {
                return this.$store.getters["global/getPageByUid"]("story", p.story.uid);
            });
        }
    },
    methods: {
        setLogo() {
            this.logoBottom = this.isHorizontal;
            this.logo = !this.isHorizontal;

            this.$nextTick(() => {
                this.$refs.section.setAnimation(true);
            });
        },
        getWebsiteName(website) {
            if (!website) {
                return;
            }

            return website.url.replace(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?/i, "").split("/")[0];
        },
        getSrcset(image) {
            const img1 = `${image.url}?w=${this.imageSize}&dpr=1`;
            const img2 = `${image.url}?w=${this.imageSize * 2}&dpr=2`;
            const img3 = `${image.url}?w=${this.imageSize * 3}&dpr=3`;
            return `${img1} ${this.imageSize}w, ${img2} ${this.imageSize * 2}w, ${img3} ${this.imageSize * 3}w`;
        },

        viewBgIntro(e) {
            gsap.to(e.target, {
                duration: 0.4,
                scaleX: this.ifHorizontal(`${1 + e.percent.center.x / 10}px`, 1),
                scaleY: this.ifHorizontal(1, `${1 + e.percent.top / 5}px`),
                ease: "sine.out"
            });
        },

        ////////////////////////////////
        //       START FIND A DATA BY SLICE TYPE
        ////////////////////////////////
        findCard(sliceType, data) {
            return data.find(x => x.slice_type === sliceType);
        }
        ////////////////////////////////
        //       END FIND A DATA BY SLICE TYPE
        ////////////////////////////////
    },
    watch: {
        isHorizontal() {
            this.setLogo();
        }
    }
};
</script>

<style lang="scss">
.p-stories__grid {
    .c-vertical-name {
        margin-top: 0px; // this is to overwrite code from somewhere else. I am might break something and not knowing somewhere else so I did this dirty trick.
    }

    @media #{$breakpoint-vertical} {
        &.-stories {
            margin-top: 0;
        }
    }
}

/*========================================
=            Economy sections            =
========================================*/

.o-economy {
    .l-section__bg {
        right: -12%;
        width: 30%;
        --color-bg: #{$color-bright};
    }

    &:nth-child(even) {
        .l-section__bg {
            --color-bg: #{$color-dark};
        }
    }

    @media (min-width: #{2 * $card-max-width}) {
        margin-top: 0 !important;
    }

    @media #{$breakpoint-vertical} {
        &:nth-child(even) {
            .c-card {
                margin-left: auto;
            }
        }

        .l-section__bg {
            display: none;
        }

        .c-card {
            max-width: 28em;
        }
    }

    @media #{$breakpoint-horizontal} {
        &:nth-child(even) {
            .o-economy__inner {
                flex-direction: column-reverse;
            }
        }
    }
}

.o-economy__inner {
    z-index: 1;

    @media #{$breakpoint-horizontal} {
        display: flex;
        flex-direction: column;

        width: 80vw;
        height: 100%;

        .o-economy__content {
            padding: 5% 8%;
            width: calc(3 / 4 * 100%);
            margin-top: auto;
            margin-bottom: auto;
        }
    }
}

.o-economy__content {
    padding: 2em 1em;

    @media #{md("xs")} {
        padding: 2.5em 1.5em;
    }

    @media #{$breakpoint-vertical} {
        max-width: 32em;
        margin-right: auto;
        margin-left: auto;
    }
}

.p-stories {
    &__inner {
        display: flex;

        flex-direction: column;
        /* width: 80vw; */
        height: 100%;
        @media #{$breakpoint-horizontal} {
            display: flex;
            flex-direction: row;
        }
    }
}
</style>
